import CommonSpacer from '@/components/sections/shared/CommonSpacer';
import ContactFormSection from './ContactFormSection';
import ContactOfficeSection from './ContactOfficeSection';
import type { ContactComponent } from '@/types/contact';
import type { CommonSpacerZone } from '@/types/homepage';
import type { LeadForm } from '@/types/lead-forms';

interface ContactSectionsProps {
  components: ContactComponent[];
  leadForms: LeadForm[];
}

function isSpacerComponent(component: ContactComponent): component is CommonSpacerZone {
  return (
    component.__component === 'common.spacer-top' ||
    component.__component === 'common.spacer-full' ||
    component.__component === 'common.spacer-bottom'
  );
}

function renderContactComponent(component: ContactComponent, leadForms: LeadForm[]) {
  if (isSpacerComponent(component)) {
    return <CommonSpacer key={component.id} zone={component} />;
  }

  if (component.__component === 'contact-us.form-section') {
    return <ContactFormSection key={component.id} section={component} leadForms={leadForms} />;
  }

  if (component.__component === 'contact-us.wonder-office') {
    return <ContactOfficeSection key={component.id} section={component} />;
  }

  return null;
}

export default function ContactSections({ components, leadForms }: ContactSectionsProps) {
  return <>{components.map((component) => renderContactComponent(component, leadForms))}</>;
}
